
import { Vague_Course } from "./Vague_Course.class";

/**
 * @classdesc Liste des vagues d'une course
 * @kind class
 * @export
 * @prop {Vague_Course[]} list - Liste des vagues de la course
 * @class List_Vagues_Course
 */
export class List_Vagues_Course {
    list = [];
    /**
     * Creates an instance of List_Vagues_Course.
     * @constructs
     * @kind function
     * @memberof List_Vagues_Course
     */
    constructor() { }

    set(data) {
        for (let i = 0; i < data.list.length; i++) {
            let vague = new Vague_Course();
            vague.set(data.list[i]);
            this.list.push(vague);
        }
    }







}